<template>
  <div style="display:flex;flex-direction:column;" class="card">
    <div
      style="padding:5px;font-size:16px; border: 1px solid #e6ecf0; background:#fff;"
    >
      {{ meetingName }}
    </div>
    <div
      class="container-fluid"
      style="min-height:90vh; padding:10px;"
      :style="this.background"
    >
      <FormQuestionner
        :checkingUrlParticipant="this.loading"
        :meetingId="this.meeting_id"
        :urlParticipant="this.url_participant"
      />
      <projectionQuestions
        style="margin-top:10px;margin-bottom:10px;"
        :checkingUrlParticipant="this.loading"
        :meetingId="this.meeting_id"
        :questions="this.questions"
        :questionsPinned="this.questionsPinned"
      />
    </div>
    <br /><br /><br /><br />
    <MyFooter window="window" v-if="!this.inIframe" />
  </div>
</template>

<script>
import axios from 'axios'
import Header from '@/components/layout/Header'
import MyFooter from '@/components/layout/MyFooter'
import FormQuestionner from '../Questionner/formQuestionner.vue'
import ProjectionQuestions from '../Questionner/projectionQuestions.vue'

export default {
  data () {
    return {
      background: '',
      inIframe: false,
      loading: true,
      url_textit: process.env.URL_MEDIA,
      url_participant: this.$route.params.url_participant,
      meeting_id: 0,
      meetingName: '',
      questions: [],
      questionsPinned: [],
      window: {
        width: window.innerWidth
      }
    }
  },
  components: {
    MyFooter,
    Header,
    FormQuestionner,
    ProjectionQuestions
  },
  created () {
    this.checkIframe()
    this.sendDataToParentFrame()

    axios.defaults.headers.common['urlparticipant'] = JSON.stringify({
      urlParticipant: this.url_participant,
      authorizedPreview: this.$store.getters.authorizedPreview,
      colideeViewResultsClient: false
    })
    axios
      .get(process.env.URL_SSO_API + 'textit/checkurlparticipant')
      .then(response => {
        console.log(response.data[0], 'meeting')
        if (!this.$store.getters.authorizedPreview) {
          if (response.data[0].state === 1) {
            if (
              (response.data[0].open_at !== '1970-01-01 00:00:00' &&
                response.data[0].open_at !== null) ||
              (response.data[0].close_at !== '1970-01-01 00:00:00' &&
                response.data[0].close_at !== null)
            ) {
              if (
                response.data[0].open_at !== '1970-01-01 00:00:00' &&
                response.data[0].open_at !== null &&
                new Date(response.data[0].open_at.replace(' ', 'T')) >=
                  new Date()
              ) {
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: this.$i18n.t('toast.reunion_invalide')
                })
                this.$router.push({ name: 'home' })
              } else if (
                response.data[0].close_at !== '1970-01-01 00:00:00' &&
                response.data[0].close_at !== null &&
                new Date(response.data[0].close_at.replace(' ', 'T')) <=
                  new Date()
              ) {
                this.$buefy.toast.open({
                  type: 'is-danger',
                  message: this.$i18n.t('toast.reunion_invalide')
                })
                this.$router.push({ name: 'home' })
              }
            }
          } else {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: this.$i18n.t('toast.reunion_invalide')
            })
            this.$router.push({ name: 'home' })
          }
        }
        // open/close survey
        if (
          response.data[0].id_entreprise !== null &&
          response.data[0].id_plateforme !== null
        ) {
          this.colidee = {
            enterprise: response.data[0].id_entreprise,
            plateforme: response.data[0].id_plateforme
          }
        }
        this.meeting_id = response.data[0].id
        this.meetingName = response.data[0].name
        if (response.data[0].media) {
          this.background =
            "background-repeat:no-repeat;background-size:cover; background-image:url('" +
            this.url_textit +
            response.data[0].media +
            "')"
        }
        this.loading = false
        // langue Colidée
        this.$i18n.locale = this.$route.params.languageColidee
        // création de la room privée pour écouter
        var room = 'Room_Textit_' + response.data[0].id
        this.$socket.emit('room', room)
        console.log('first-connect')
        this.fetchQuestions()
      })
      .catch(error => {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: this.$i18n.t('toast.reunion_invalide')
        })
        this.$router.push({ name: 'home' })
      })
  },

  updated () {
    this.$nextTick(function () {
      let message = {
        task: 'updateHeight',
        height: document.body.scrollHeight
      }
      window.top.postMessage(message, '*')
    })
  },

  methods: {
    fetchQuestions () {
      axios.defaults.headers.common['urlparticipant'] = this.url_participant;
      axios
        .get(
          process.env.URL_SSO_API +
            'textit/public/meeting/' +
            this.meeting_id +
            '/question'
        )
        .then(response => {
          /* On récupère toutes les questions qui ne sont pas mise en avant */
          this.questions = response.data.filter(
            question => question.pinned == '0' && question.state == 'published'
          )
          /* On récupère toutes les questions qui sont mise en avant */
          this.questionsPinned = response.data.filter(
            question => question.pinned == '1' && question.state == 'published'
          )
          this.loading = false
        })
        .catch(error => {
          // window.close();
          console.log(error)
        })
    },

    checkIframe () {
      if (window.location !== window.parent.location) {
        this.inIframe = true
      } else {
        this.inIframe = false
      }
    },

    sendDataToParentFrame () {
      let message = {
        height: document.body.scrollHeight,
        width: document.body.scrollWidth
      }
      window.top.postMessage(message, '*')
    }
  },

  sockets: {
    connect () {
      if (this.meeting_id) {
        var room = 'Room_Textit_' + this.meeting_id
        this.$socket.emit('room', room)
        console.log('re-connect')
      }
    },
    disconnect () {
      console.log('disconnect')
    },
    channel (data) {
      data = JSON.parse(decodeURIComponent(data))
      /** BLOC NOUVELLE QUESITON QUI ARRIVE EN TEMPS REEL */
      if (data.type === 'NEW_QUESTION') {
        if (data.question.state === 'published') {
          this.questions.unshift(data.question)
        } else {
          // Fix un bug où le tableau this.questions se remplissait sans qu'on lui demande
          if (
            Object.values(this.questions).length == 0 &&
            Object.keys(this.questions).length == 0
          ) {
            this.questions = []
          }
        }

        this.questions = this.questions.filter(
          (thing, index, self) =>
            index === self.findIndex(t => t.id === thing.id)
        )
      }

      /** BLOC SUPPRESSION D'UNE QUESITON EN TEMPS REEL */
      if (data.type === 'DELETE_QUESTION') {
        for (var i = this.questions.length - 1; i >= 0; i--) {
          if (this.questions[i].id === data.question.id) {
            this.questions.splice(i, 1)
          }
        }
      }

      /** BLOC QUESTION EST MIS A JOUR */
      if (data.type == 'UPDATE_QUESTION') {
        // en  priorité on  cherche si la question est visible à l'écran (index>-1 pour visible ou -1 si pas  présente = pending)
        let index = this.questions.findIndex(
          question => question.id === data.question.id
        )

        // On cherche si elle est présente dans les mise avant
        let indexPinned = this.questionsPinned.findIndex(
          question => question.id === data.question.id
        )

        if (data.question.state == 'pending') {
          if (index != -1) {
            this.questions = this.questions.filter(
              question => question.id != data.question.id
            )
          } else if (indexPinned != -1) {
            this.questionsPinned = this.questionsPinned.filter(
              question => question.id != data.question.id
            )
          }
        }

        if (data.question.pinned == '0') {
          // Si published et pas présent on le rajoute
          if (data.question.state == 'published' && index == -1) {
            this.questions.unshift(data.question)
          }

          // Si question publiée et déjà proposée en  projection ==> cas de la modification d'un intitule de question
          if (data.question.state == 'published' && index != -1) {
            this.questions[index].question = data.question.question
          }

          // Si la question est afficher à l'écran mais on enleve la mise en avant
          if (data.question.state == 'published' && indexPinned != -1) {
            this.questionsPinned = this.questionsPinned.filter(
              question => question.id != data.question.id
            )
          }
        } else {
          // Si published et pas présent on le rajoute
          if (data.question.state == 'published' && indexPinned == -1) {
            this.questionsPinned.unshift(data.question)
          }

          // Si question publiée et déjà proposée en  projection ==> cas de la modification d'un intitule de question
          if (data.question.state == 'published' && indexPinned != -1) {
            this.questionsPinned[indexPinned].question = data.question.question
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/QuestionnerColidee.vue